import { Calendar, getCalendarEntry } from 'owa-calendar-cache';

import { getCalendars } from './getCalendars';

/**
 * Returns shareable calendars from store
 * @returns collection of shareable calendars
 */
export function getShareableCalendars(): Calendar[] {
    let result: Calendar[] = [];
    getCalendars().forEach(calendar => {
        let calendarEntry: any = getCalendarEntry(calendar);
        if (calendarEntry?.CanShare) {
            result.push(calendar);
        }
    });
    return result;
}
